import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainMenuService {

  private mainmenuSubject = new BehaviorSubject<any>([]);

  mainmenu$ = this.mainmenuSubject.asObservable();

  constructor() { }

  addButtons(buttons){
    this.mainmenuSubject.subscribe(buttons);
  }

  updateButtons(buttons) {
    this.mainmenuSubject.next(buttons);
  }

  reloadButtons(){
    this.mainmenuSubject.next(this.mainmenuSubject.value);
  }

}
